import React from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';

import LogoUrl from './../../assets/img/logo_negative.svg';
import SmartLink from "../../lib/includes/components/component.smartlink";

const Footer = (props) => {
    if (!props.general) {
      return null;
    }

    let footer = props.general.footer;

    return <footer className="site-footer">
        <div className="container">
            <div className="row row-lg">
                <div className="col-lg-6 col-logo">
                    <Link to="/" className="logo">
                        <img src={LogoUrl} alt={props.general.title}/>
                    </Link>
                    <div className="site-footer-text">
                        <div className="rte-content" dangerouslySetInnerHTML={{__html : footer.text}}></div>

                        {footer.social &&
                            <ul className="nav nav-icons">
                                {footer.social.map((item, i) => {
                                    return <li key={i} className="nav-item">
                                        <a href={item.url} target="_blank" className="button button-light-outline button-icon-only"><i className={"fab fa-" + item.icon}></i></a>
                                    </li>
                                })}
                            </ul>
                        }
                    </div>
                </div>

                {footer.columns && footer.columns.map((col, i) => {
                    return <div key={i} className="col-lg col-nav">
                        <h3>{col.title}</h3>
                        <ul className="nav">
                            {col.links.map((item, i) => {
                                return <li key={i} className="nav-item">
                                    <SmartLink url={item.link.url} target={item.link.target} className="nav-link">{item.link.title}</SmartLink>
                                </li>
                            })}
                        </ul>
                    </div>
                })}

            </div>
        </div>
    </footer>
};

export default connect(
  state => {
    return {
      general: state.generalState.general
    }
  },
)(Footer);
